<template style="background-color:#666">
    <span>
      <div class="footer_box">
        <img src="../assets/footer_pic.jpg" class="only_pc">
        <img src="../assets/footer_pic_mb.jpg" class="only_mb">
        <router-link to="ApplicationForm">
          <btn class="footer_apply"  v-if="$route.name.indexOf('/ApplicationForm') < 0"  data-cursor-hover>応募する</btn>
        </router-link>
      </div>

      <div style="text-align:center;color:#FFF;padding:40px;background-color:#c04d00">
        <span class="footer_item">
          <a class="footer_item_link" href="https://www.he-service.co.jp/" target="brank" data-cursor-hover>コーポレートサイト</a>
        </span>｜
        <span class="footer_item">
          <a class="footer_item_link" href="https://www.he-service.co.jp/cml.html#cml_tabs_B" target="brank" data-cursor-hover>プライバシーポリシー</a>
        </span>｜
        <span class="footer_item">
          <a class="footer_item_link" href="https://www.he-service.co.jp/ctt.html" target="brank" data-cursor-hover>お問い合わせ</a>
        </span>
      </div>

      <div style="text-align:center;color:#efefef;padding-bottom:80px;background-color:#c04d00">
        Copyright © 2022 HES Co.,Ltd. All Rights Reserved.
      </div>

    </span>
</template>

<script>

</script>

<!-- style中身は省略 -->
<style scoped>
.footer_box{
  width: 100%;
  height: auto;
  position: relative;
  background: #c04d00;
}
.footer_apply{
  position: absolute;
  top: 50%;
  left: 50%;
  color: #efefef;
  -ms-transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
  padding: 1.2em 10em;
  background-color: rgba(192,77,0,.9);
  border: solid 0.5px #efefef;
  /* cursor: pointer; */
  overflow: hidden;
  font-size: 1.4rem;
  font-weight: bold;
}
.footer_box img {
  width: 100%;
}
.footer_apply::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 0%;
    background-color: rgba(107,64,0,0.5);
    -webkit-transition: .2s;
    transition: .2s;
}
.footer_apply:hover::before{
    height: 100%;
}


.footer_item{
  margin: 0 40px;
  font-size: 1.2rem;
}
.footer_item_link{
  text-decoration: none;
  color: #efefef;
  display: inline-block;
	position: relative;
  cursor: none;
}
.footer_item_link::after {
	position: absolute;
	content: '';
	bottom: 0;
	left: 0;
	width: 0;
	height: 1px;
	background: #efefef;
	transition: all 0.3s ease 0s;
}
.footer_item_link:hover {
	cursor: none;
}
.footer_item_link:hover::after {
	width: 100%;
}

@media screen and (max-width: 480px) {
  html{
    font-size: 35% !important;
  }
  .footer_item{
    margin: 0 2px;
  }
  .footer_apply{
    position: absolute;
    /* top: 70%; */
    left: 50%;
    color: #efefef;
    -ms-transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    padding: 1em 10em;
    background-color: rgba(192,77,0,0.9);
    border: solid 0.5px #efefef;
    /* cursor: pointer; */
    overflow: hidden;
  }
  .footer_item_link:hover::after {
    width: 0%;
  }
  .footer_box btn{
    font-size: 2rem;
    width: 75%;
    text-align: center;
  }
  .footer_box img {
    /* display: none; */
  }
  .footer_box{
    /* padding-top: 80px; */
  }
}
@media screen and (min-width: 481px) and (max-width: 959px) {
	html{
    font-size: 50% !important;
  }
  .footer_item{
    margin: 0 15px;
  }
  .footer_apply{
    position: absolute;
    top: 50%;
    left: 50%;
    color: #efefef;
    -ms-transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    padding: 1.2em 12em;
    background-color: rgba(192,77,0,0.5);
    border: solid 0.5px #efefef;
    /* cursor: pointer; */
    overflow: hidden;
  }
}
@media screen and (min-width: 960px) and (max-width: 1200px) {
	html {
        font-size: 62.5% !important;
  }
  .footer_apply{
    position: absolute;
    top: 50%;
    left: 50%;
    color: #efefef;
    -ms-transform: translate(-50%,-50%);
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    padding: 1.5em 15em;
    background-color: rgba(192,77,0,0.5);
    border: solid 0.5px #efefef;
    /* cursor: pointer; */
    overflow: hidden;
  }
}
@media screen and (min-width: 1201px) and (max-width: 1500px)  {
	html {
        font-size: 62.5% !important;
    }
}
</style>

<script>
export default {
  methods: {
    
  }
}
</script>